import { render, staticRenderFns } from "./exchange-block.vue?vue&type=template&id=5c832547&scoped=true&lang=pug&"
import script from "./exchange-block.vue?vue&type=script&lang=js&"
export * from "./exchange-block.vue?vue&type=script&lang=js&"
import style0 from "./exchange-block.vue?vue&type=style&index=0&id=5c832547&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c832547",
  null
  
)

export default component.exports